@let badgeInfoValue = badgeInfo();

<div
  [rtTooltip]="badgeInfoValue.tooltip"
  [rtTooltipEnabled]="!!badgeInfoValue.tooltip"
  [rtTooltipPosition]="'right'"
>
  <rt-badge
    [color]="'counter-light'"
    [text]="badgeInfoValue.label"
    [iconTmpl]="iconTemplate"
    class="transform-none"
  />
</div>

<ng-template #iconTemplate>
  <rt-icon
    size="small-xx"
    [name]="badgeInfoValue.iconName"
    [colorToken]="badgeInfoValue.iconColor"
    margin-right-small-xx
  />
</ng-template>
